(function () {
  'use strict';

  var O = window.MMOffers || {};
  var TYPE_COLORS = {
    BUNDLE: { grad: 'linear-gradient(135deg,#1E3A8A,#2563EB)', accent: '#2563EB' },
    BOGO: { grad: 'linear-gradient(135deg,#9F1239,#DC2626)', accent: '#DC2626' },
    VOLUME: { grad: 'linear-gradient(135deg,#4C1D95,#7C3AED)', accent: '#7C3AED' }
  };
  var TYPE_LABELS = { BUNDLE: 'Bundle Deal', BOGO: 'Buy X Get Y', VOLUME: 'Volume Savings' };

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function shopRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.endsWith('/') ? r.slice(0, -1) : r;
  }

  function fetchProductJs(handle) {
    if (!handle) return Promise.resolve(null);
    if (window.__mmPrefetch && typeof window.__mmPrefetch.fetchProduct === 'function') {
      return window.__mmPrefetch.fetchProduct(handle);
    }
    return fetch(shopRoot() + '/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchProductsJs(handles) {
    var list = (handles || []).filter(Boolean);
    if (!list.length) return Promise.resolve([]);
    if (window.__mmPrefetch && typeof window.__mmPrefetch.fetchProducts === 'function') {
      return window.__mmPrefetch.fetchProducts(list);
    }
    return Promise.all(list.map(fetchProductJs));
  }

  function isAr(el) {
    var lang = (el && el.getAttribute('data-lang')) || (window.Shopify && window.Shopify.locale) || 'en';
    return String(lang).toLowerCase().indexOf('ar') === 0;
  }

  function jp(raw, fb) {
    if (O.jp) return O.jp(raw, fb);
    if (raw == null) return fb != null ? fb : [];
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw || '[]'); } catch (e) { return fb != null ? fb : []; }
  }

  function slugFromUrl() {
    var p = new URLSearchParams(window.location.search);
    return p.get('slug') || p.get('o') || p.get('mm_offer_slug') || '';
  }

  function findOffer(offers, slug) {
    if (!slug) return null;
    var s = String(slug);
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      if (String(o.slug) === s || String(o.id) === s) return o;
    }
    return null;
  }

  function labels(settings, ar) {
    var s = settings || {};
    function L(en, arKey) { return ar ? (s[arKey] || en) : (s[en] || en); }
    return {
      buy: ar ? (s.buyAr || 'اشتري') : (s.buyEn || 'BUY'),
      get: ar ? (s.getAr || 'احصل على') : (s.getEn || 'GET'),
      free: ar ? (s.freeAr || 'مجاناً') : (s.freeEn || 'FREE'),
      save: ar ? (s.youSaveAr || 'توفيرك') : (s.youSaveEn || 'You save'),
      atc: ar ? (s.addToCartAr || 'إضافة لمشترياتي') : (s.addToCartEn || 'Add to Cart'),
      select: ar ? (s.selectOptionsAr || 'اختر خياراتك') : (s.selectOptionsEn || 'Select Options'),
      secure: ar ? (s.securePaymentAr || 'دفع آمن') : (s.securePaymentEn || 'Secure Payment'),
      quality: ar ? (s.qualityGuaranteedAr || 'جودة مضمونة') : (s.qualityGuaranteedEn || 'Quality Guaranteed'),
      back: ar ? (s.backToHomeAr || 'العودة للرئيسية') : (s.backToHomeEn || 'Back to Home'),
      endsIn: ar ? (s.endsInAr || 'ينتهي خلال {timer}') : (s.endsInEn || 'Ends in {timer}'),
      viewOffer: ar ? 'شاهد العرض' : 'View Offer',
      otherRecs: ar ? 'عروض أخرى قد تعجبك' : 'Other offers you might like',
      onlyLeft: ar ? 'متبقي {n} قطعة فقط!' : 'Only {n} left in stock!',
      expired: ar ? 'انتهى' : 'Expired',
      adding: ar ? 'جاري الإضافة...' : 'Adding...',
      added: ar ? 'تمت الإضافة!' : 'Added!',
      includedFlavors: ar ? 'النكهات المشمولة:' : 'Included Flavors:',
      notFound: ar ? 'العرض غير متوفر' : 'Offer not available',
      notFoundDesc: ar ? 'قد يكون العرض منتهياً أو الرابط غير صحيح.' : 'This offer may have ended or the link is incorrect.',
      chooseOneProduct: ar ? 'اختر أحد المنتجين' : 'Pick one product',
      thenChooseFlavour: ar ? 'ثم اختر النكهة' : 'Then choose flavour',
      chooseFlavour: ar ? 'اختر النكهة' : 'Choose flavour',
      chooseFlavourEach: ar ? 'اختر النكهة لكل قطعة' : 'Choose flavour for each item',
      volumeQtyTitle: ar ? 'اختر الكمية والخصم' : 'Choose quantity & discount',
      volumeHowTitle: ar ? 'كيف يعمل العرض؟' : 'How it works',
      volumeHowText: ar ? 'اختر الكمية المناسبة — كل مستوى يعطيك خصم أوضح. ثم اختر النكهة لكل قطعة.' : 'Pick your quantity — each tier shows the discount. Then choose a flavour for each piece.',
      regularPrice: ar ? 'السعر الأصلي' : 'Regular price',
      bestValue: ar ? 'أفضل قيمة' : 'Best value',
      total: ar ? 'الإجمالي' : 'Total',
      perPc: ar ? 'للقطعة' : 'per piece',
      itemN: ar ? 'القطعة' : 'Item'
    };
  }

  function parseBogoQty(offer) {
    var buy = 2, get = 1;
    try {
      var ds = jp(offer.displaySettings, {});
      if (ds.bogoQtyBuy) buy = parseInt(ds.bogoQtyBuy, 10) || 2;
      if (ds.bogoQtyGet) get = parseInt(ds.bogoQtyGet, 10) || 1;
    } catch (e) {}
    return { buy: buy, get: get };
  }

  function parseBundleItems(offer) {
    var bogoQty = parseBogoQty(offer);
    var bundleItems = [];

    if (offer.type === 'BOGO') {
      var bogoConfig = jp(offer.bundleItemsConfig, {});
      if (bogoConfig && (bogoConfig.trigger || bogoConfig.target)) {
        if (bogoConfig.trigger) bundleItems.push(Object.assign({}, bogoConfig.trigger, { quantity: bogoQty.buy, isTrigger: true }));
        if (bogoConfig.target) bundleItems.push(Object.assign({}, bogoConfig.target, { quantity: bogoQty.get, isTarget: true }));
      } else if (Array.isArray(bogoConfig) && bogoConfig.length) {
        bundleItems.push(Object.assign({}, bogoConfig[0], { quantity: bogoQty.buy, isTrigger: true }));
        bundleItems.push(Object.assign({}, bogoConfig[1] || bogoConfig[0], { quantity: bogoQty.get, isTarget: true }));
      }
      if (!bundleItems.length) {
        var triggers = jp(offer.triggerProducts, []);
        var targets = jp(offer.targetProducts, []);
        var th = triggers[0] || '';
        var tg = targets[0] || th;
        if (th) bundleItems.push({ handle: th, variantMode: 'all', quantity: bogoQty.buy, isTrigger: true, discount: '0' });
        if (tg) bundleItems.push({ handle: tg, variantMode: 'all', quantity: bogoQty.get, isTarget: true, discount: '100' });
      }
      return { items: bundleItems, bogoQty: bogoQty };
    }

    bundleItems = jp(offer.bundleItemsConfig, []);
    if (!Array.isArray(bundleItems)) bundleItems = [];
    var triggerHandles = jp(offer.triggerProducts, []);
    if (!bundleItems.length && triggerHandles.length) {
      bundleItems = triggerHandles.map(function (h) {
        return { handle: h, variantMode: 'all', discount: '0' };
      });
    }
    return { items: bundleItems, bogoQty: bogoQty };
  }

  function offerTitle(offer, ar) {
    if (ar && offer.titleAr) return offer.titleAr;
    return offer.title || offer.name || '';
  }

  function offerDesc(offer, ar) {
    if (ar && offer.descriptionAr) return offer.descriptionAr;
    return offer.description || '';
  }

  function eidEnabled(settings) {
    try {
      var cfg = jp(settings.shopifyDealsConfig, {});
      return !!cfg.eidThemeEnabled;
    } catch (e) { return false; }
  }

  function recUrl(offer) {
    if (O.offerNavUrl) return O.offerNavUrl(offer, 'offer-page');
    return shopRoot() + '/pages/offer?slug=' + encodeURIComponent(offer.slug || offer.id);
  }

  async function loadOfferBySlug(slug) {
    if (O.offersSnapshot) {
      var snap = O.offersSnapshot();
      if (snap && snap._ok && snap.offers) {
        var snapHit = findOffer(snap.offers, slug);
        if (snapHit) return { offers: snap.offers, offer: snapHit, settings: snap.settings || {} };
      }
    }
    if (window.__mmPrefetch && window.__mmPrefetch.cache && window.__mmPrefetch.cache.offers) {
      var c = window.__mmPrefetch.cache.offers;
      if (c._ok && c.offers) {
        var hit = findOffer(c.offers, slug);
        if (hit) return { offers: c.offers, offer: hit, settings: c.settings || {} };
      }
    }
    if (window.__mmOffersPreload) {
      try {
        var pre = await window.__mmOffersPreload;
        var h = findOffer(pre.offers || [], slug);
        if (h) return { offers: pre.offers || [], offer: h, settings: pre.settings || {} };
      } catch (e) {}
    }
    try {
      var url = window.MMOffers && window.MMOffers.offersApiUrl
        ? window.MMOffers.offersApiUrl({ slug: slug })
        : '/apps/mm-app/api/offers?slug=' + encodeURIComponent(slug);
      var r = await fetch(url);
      if (r.ok) {
        var data = await r.json();
        var o = findOffer(data.offers || [], slug);
        if (o) return { offers: data.offers || [], offer: o, settings: data.settings || {} };
      }
    } catch (e) {}
    if (O.loadOffersList) {
      var full = await O.loadOffersList({ maxWait: 3000 });
      var f = findOffer(full.offers || [], slug);
      if (f) return { offers: full.offers || [], offer: f, settings: full.settings || {} };
    }
    return { offers: [], offer: null, settings: {} };
  }

  function renderShell(el, offer, settings, otherOffers) {
    var ar = isAr(el);
    var L = labels(settings, ar);
    var colors = TYPE_COLORS[offer.type] || TYPE_COLORS.BUNDLE;
    var badge = TYPE_LABELS[offer.type] || 'Exclusive Offer';
    if (ar) badge = offer.type === 'BUNDLE' ? 'باقة توفير حصرية' : (offer.type === 'BOGO' ? 'عرض خاص محدود' : 'خصم كمية');
    var images = jp(offer.images, []);
    var desc = offerDesc(offer, ar);
    var dir = ar ? 'rtl' : 'ltr';
    var eid = eidEnabled(settings) ? ' mm-eid-theme' : '';
    var gallery = '';

    if (images.length) {
      gallery = '<div class="mm-op-gallery-main"><img src="' + esc(images[0]) + '" alt="" id="mm-op-gallery-main-img"></div>';
      if (images.length > 1) {
        gallery += '<div class="mm-op-gallery-thumbs">' + images.map(function (img, i) {
          return '<img src="' + esc(img) + '" alt="" class="mm-op-thumb' + (i === 0 ? ' active' : '') + '" data-thumb="' + esc(img) + '">';
        }).join('') + '</div>';
      }
    } else {
      gallery = '<div id="mm-op-prod-hero" class="mm-op-gallery-main"></div>';
    }

    var timer = '';
    if (offer.endsAt) {
      timer = '<div class="mm-op-timer-wrap"><div class="mm-op-timer-label">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> ' +
        L.endsIn.replace('{timer}', '<span id="mm-op-timer">...</span>') + '</div></div>';
    }

    var scarcity = '';
    if (offer.customerQuantity > 0) {
      scarcity = '<div class="mm-op-scarcity-wrap"><div class="mm-op-scarcity-label">' +
        esc(L.onlyLeft.replace('{n}', offer.customerQuantity)) +
        '</div><div class="mm-op-progress-bg"><div class="mm-op-progress-fill"></div></div></div>';
    }

    var recs = '';
    if (otherOffers.length) {
      recs = '<div class="mm-op-recs"><h2 class="mm-op-recs-title">' + esc(L.otherRecs) + '</h2><div class="mm-op-recs-grid">' +
        otherOffers.map(function (o) {
          var imgs = jp(o.images, []);
          var img = imgs[0] || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_small.png';
          return '<a href="' + esc(recUrl(o)) + '" class="mm-op-rec-card">' +
            '<img src="' + esc(img) + '" alt="">' +
            '<div class="mm-op-rec-info"><h3>' + esc(offerTitle(o, ar)) + '</h3><span>' + esc(L.viewOffer) + ' →</span></div></a>';
        }).join('') + '</div></div>';
    }

    el.innerHTML =
      '<div class="mm-op-wrapper' + eid + '" dir="' + dir + '" data-offer-type="' + esc(offer.type) + '" style="--mm-accent:' + colors.accent + ';--mm-atc-grad:' + colors.grad + '">' +
        '<nav class="mm-op-breadcrumb"><a href="' + esc(shopRoot() || '/') + '">' + esc(L.back) + '</a><span>/</span><strong>' + esc(badge) + '</strong></nav>' +
        '<div class="mm-op-main">' +
          '<div class="mm-op-gallery-container">' + gallery + '</div>' +
          '<div class="mm-op-details">' +
            '<div class="mm-op-header"><div class="mm-op-top-badge">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg> ' +
              esc(badge) + '</div><h1>' + esc(offerTitle(offer, ar)) + '</h1></div>' +
            '<div class="mm-op-price-wrap">' +
              '<span class="mm-op-price-current" id="mm-op-price-new">…</span>' +
              '<span class="mm-op-price-compare" id="mm-op-price-old"></span>' +
              '<span class="mm-op-save-badge" id="mm-op-savings"></span>' +
            '</div>' + timer + scarcity +
            '<div class="mm-op-picker"><div class="mm-op-picker-title">' + esc(L.select) + '</div>' +
              '<div class="mm-op-products-list" id="mm-op-products"><div class="mm-op-loading">...</div></div></div>' +
            '<div class="mm-op-action-box"><button class="mm-op-atc-btn" id="mm-op-atc" disabled>' + esc(L.atc) + '</button>' +
              '<div class="mm-op-trust">' +
                '<div class="mm-op-trust-item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' + esc(L.secure) + '</div>' +
                '<div class="mm-op-trust-item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>' + esc(L.quality) + '</div>' +
              '</div></div>' +
            (desc ? '<div class="mm-op-desc">' + desc + '</div>' : '') +
          '</div></div>' + recs + '</div>';

    el.querySelectorAll('.mm-op-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.getElementById('mm-op-gallery-main-img');
        if (main) main.src = thumb.getAttribute('data-thumb');
        el.querySelectorAll('.mm-op-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  function initVolumeLogic(offer, settings, el) {
    var ar = isAr(el);
    var L = labels(settings, ar);
    var UI = window.MMOfferLandingUI || {};
    var tax = parseFloat(settings.taxPercentage || 10) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BHD';
    var root = shopRoot();
    var config = jp(offer.bundleItemsConfig, []);
    var productConfig = config[0] || {};
    var handle = productConfig.handle || (jp(offer.triggerProducts, [])[0]) || '';
    var pickerTitle = document.querySelector('.mm-op-picker-title');
    if (pickerTitle) pickerTitle.textContent = L.volumeQtyTitle;

    function fmt(minor) {
      if (O.fmtPrice) return O.fmtPrice(minor, el);
      var div = 1000;
      var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
      if (htmlDiv === 100 || htmlDiv === 1000) div = htmlDiv;
      var total = minor * (1 + tax);
      var dec = (currency === 'BHD' || currency === 'KWD' || currency === 'OMR') ? 3 : 2;
      var amt = (total / div).toFixed(dec);
      if (ar) return amt + ' د.ب';
      return amt + ' ' + currency;
    }

    var selectedQty = 1;
    var discountVal = 0;
    var discountType = offer.discountType || 'PERCENTAGE';
    var basePrice = 0;
    var triggerP = null;
    var filteredVariants = [];

    function volUnits(variant) {
      if (O.volumeUnitLabels) return O.volumeUnitLabels(triggerP, variant, ar);
      return ar ? { one: 'قطعة', many: 'قطع' } : { one: 'piece', many: 'pieces' };
    }

    function onVolVariantSelect(picker, vid) {
      if (!triggerP) return;
      var selVar = filteredVariants.find(function (v) { return String(v.id) === String(vid); });
      if (!selVar) return;
      UI.setGalleryImage(UI.variantImageUrl(triggerP, selVar) || productConfig.image);
      basePrice = selVar.price || basePrice;
      refreshVolTierRowPrices();
      updateVolPrice();
    }

    function refreshVolTierRowPrices() {
      var box = document.getElementById('mm-op-products');
      if (!box) return;
      var units = volUnits(filteredVariants[0]);
      box.querySelectorAll('.mm-vol-row').forEach(function (row) {
        var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
        var dVal = parseFloat(row.getAttribute('data-discount') || '0');
        var dtype = row.getAttribute('data-dtype') || discountType;
        var totalOrig = basePrice * qty;
        var discCents = dtype === 'PERCENTAGE'
          ? Math.round(totalOrig * (dVal / 100))
          : Math.round(dVal * 100);
        var newTotal = Math.max(0, totalOrig - discCents);
        var priceEl = row.querySelector('.mm-vol-row__price-val');
        if (priceEl) priceEl.textContent = fmt(newTotal);
        var perUnit = qty > 0 && dVal > 0 ? fmt(Math.round(newTotal / qty)) : '';
        var subEl = row.querySelector('.mm-vol-row__sub');
        if (subEl && perUnit) subEl.textContent = perUnit + ' / ' + units.one;
        var qtyEl = row.querySelector('.mm-vol-row__qty');
        if (qtyEl) {
          qtyEl.textContent = qty === 1 ? ('1 ' + units.one) : (qty + ' ' + units.many);
        }
      });
    }

    function renderFlavorPickers(qty) {
      var wrap = document.getElementById('mm-op-vol-flavors');
      if (!wrap || !triggerP) return;
      var pickerCtx = {
        product: triggerP,
        variants: filteredVariants,
        onSelect: onVolVariantSelect
      };
      if (qty <= 1) {
        if (filteredVariants.length <= 1) {
          wrap.innerHTML = '';
          wrap.hidden = true;
          return;
        }
        wrap.hidden = false;
        wrap.innerHTML = '<div class="mm-op-step-label mm-op-step-label--flavor"><span class="mm-op-step-num">2</span>' + esc(L.chooseFlavour) + '</div>' +
          UI.buildVariantPickerHtml({ idx: 'vol0', variants: filteredVariants, selectedId: filteredVariants[0].id, hint: L.chooseFlavour, slot: 'vol', product: triggerP });
        UI.wireVariantPickers(wrap, pickerCtx);
        return;
      }
      wrap.hidden = false;
      var html = '<div class="mm-op-step-label mm-op-step-label--flavor"><span class="mm-op-step-num">2</span>' + esc(L.chooseFlavourEach) + '</div><div class="mm-op-vol-flavor-list">';
      for (var i = 0; i < qty; i++) {
        html += '<div class="mm-op-vol-flavor-row"><span class="mm-op-vol-flavor-idx">' + esc(L.itemN) + ' ' + (i + 1) + '</span>' +
          UI.buildVariantPickerHtml({ idx: 'vol' + i, variants: filteredVariants, selectedId: filteredVariants[0].id, hint: L.chooseFlavour, slot: 'vol', product: triggerP }) +
        '</div>';
      }
      html += '</div>';
      wrap.innerHTML = html;
      UI.wireVariantPickers(wrap, pickerCtx);
    }

    function updateVolPrice() {
      var totalOrig = basePrice * selectedQty;
      var discCents = discountType === 'PERCENTAGE'
        ? Math.round(totalOrig * (discountVal / 100))
        : Math.round(discountVal * 100);
      var final = Math.max(0, totalOrig - discCents);
      var pct = totalOrig > 0 ? Math.round((discCents / totalOrig) * 100) : 0;
      var newEl = document.getElementById('mm-op-price-new');
      var oldEl = document.getElementById('mm-op-price-old');
      var saveEl = document.getElementById('mm-op-savings');
      if (newEl) newEl.textContent = fmt(final);
      if (oldEl) oldEl.textContent = selectedQty > 0 && discCents > 0 ? fmt(totalOrig) : '';
      if (saveEl) saveEl.textContent = pct > 0 ? ((ar ? 'وفر ' : 'Save ') + pct + '%') : '';
    }

    async function init() {
      var box = document.getElementById('mm-op-products');
      if (!box || !handle) {
        if (box) box.innerHTML = '<div class="mm-op-loading">—</div>';
        return;
      }
      try {
        triggerP = await fetchProductJs(handle);
        if (!triggerP) throw new Error('product');
        filteredVariants = UI.filterVariants(triggerP, productConfig);
        basePrice = (filteredVariants[0] && filteredVariants[0].price) || (triggerP.variants[0] && triggerP.variants[0].price) || 0;

        UI.setGalleryImage(productConfig.image || UI.variantImageUrl(triggerP, filteredVariants[0]));

        var tiers = jp(offer.volumeTiers, []);
        tiers.sort(function (a, b) { return a.qty - b.qty; });
        var bestIdx = tiers.length - 1;
        var units = volUnits(filteredVariants[0]);
        var hasTierQty1 = tiers.some(function (t) {
          return parseInt(t.qty, 10) === 1 && parseFloat(t.discount || 0) > 0;
        });
        var rowsHtml = '';

        if (!hasTierQty1) {
          rowsHtml = UI.volTierRow({
            qty: 1, active: true, discount: 0, dtype: '', ar: ar,
            unitOne: units.one, unitMany: units.many,
            meta: L.regularPrice, disc: '', price: fmt(basePrice), totalLabel: L.total
          });
        }

        tiers.forEach(function (tier, i) {
          var tierQty = parseInt(tier.qty, 10) || 1;
          var totalOrig = basePrice * tierQty;
          var dVal = parseFloat(tier.discount || 0);
          var discCents = discountType === 'PERCENTAGE'
            ? Math.round(totalOrig * (dVal / 100))
            : Math.round(dVal * 100);
          var newTotal = Math.max(0, totalOrig - discCents);
          var discLabel = discountType === 'PERCENTAGE'
            ? (dVal + '% ' + (ar ? 'خصم' : 'off'))
            : (fmt(discCents) + ' ' + (ar ? 'خصم' : 'off'));
          var perUnit = tierQty > 0 ? fmt(Math.round(newTotal / tierQty)) : '';
          var isActive = hasTierQty1 ? tierQty === 1 : false;
          rowsHtml += UI.volTierRow({
            qty: tierQty, active: isActive, discount: dVal, dtype: discountType, ar: ar,
            unitOne: units.one, unitMany: units.many,
            badge: i === bestIdx ? L.bestValue : '',
            meta: perUnit ? (perUnit + ' / ' + units.one) : '',
            disc: discLabel, price: fmt(newTotal), totalLabel: L.total
          });
        });

        if (hasTierQty1) {
          var tier1 = tiers.find(function (t) { return parseInt(t.qty, 10) === 1; });
          selectedQty = 1;
          discountVal = parseFloat((tier1 && tier1.discount) || 0);
          discountType = offer.discountType || 'PERCENTAGE';
        }

        box.innerHTML =
          '<p class="mm-op-volume-hint">' + esc(L.volumeHowText) + '</p>' +
          '<div class="mm-vol-rows mm-op-vol-rows">' + rowsHtml + '</div>' +
          '<div id="mm-op-vol-flavors" class="mm-op-vol-flavors" hidden></div>';

        box.querySelectorAll('.mm-vol-row').forEach(function (row) {
          function activate() {
            box.querySelectorAll('.mm-vol-row').forEach(function (r) {
              r.classList.remove('active');
              var radio = r.querySelector('input[type="radio"]');
              if (radio) radio.checked = false;
            });
            row.classList.add('active');
            var thisRadio = row.querySelector('input[type="radio"]');
            if (thisRadio) thisRadio.checked = true;
            selectedQty = parseInt(row.getAttribute('data-qty'), 10) || 1;
            discountVal = parseFloat(row.getAttribute('data-discount') || '0');
            discountType = row.getAttribute('data-dtype') || offer.discountType || 'PERCENTAGE';
            updateVolPrice();
            renderFlavorPickers(selectedQty);
          }
          row.addEventListener('click', activate);
          row.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
          });
        });

        updateVolPrice();
        renderFlavorPickers(selectedQty);
        var atc = document.getElementById('mm-op-atc');
        if (atc) atc.disabled = false;
        if (offer.endsAt) UI.startTimer(offer.endsAt, document.getElementById('mm-op-timer'), L, ar);
      } catch (e) {
        box.innerHTML = '<div class="mm-op-loading">—</div>';
      }
    }

    var atcBtn = document.getElementById('mm-op-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', async function () {
        atcBtn.disabled = true;
        var original = atcBtn.textContent;
        atcBtn.textContent = L.adding;
        try {
          var variantCounts = {};
          var flavorWrap = document.getElementById('mm-op-vol-flavors');
          var pickers = flavorWrap ? flavorWrap.querySelectorAll('[data-mm-op-variant-picker]') : [];
          if (selectedQty > 1 && pickers.length > 1) {
            pickers.forEach(function (picker) {
              var vid = picker.getAttribute('data-selected-id') || (filteredVariants[0] && filteredVariants[0].id);
              variantCounts[vid] = (variantCounts[vid] || 0) + 1;
            });
          } else {
            var vid = filteredVariants[0] && filteredVariants[0].id;
            if (pickers.length) {
              var p0 = pickers[0];
              vid = p0.getAttribute('data-selected-id') || vid;
            }
            variantCounts[vid] = selectedQty;
          }
          var bundleGroupId = 'bg_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          var items = [];
          Object.keys(variantCounts).forEach(function (vid) {
            items.push({
              id: parseInt(vid, 10),
              quantity: variantCounts[vid],
              properties: { _offerId: offer.id, _offerType: 'VOLUME', _bundleGroupId: bundleGroupId }
            });
          });
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
          var offerKey = String(offer.id);
          var volDeals = items.map(function (it) {
            return {
              variantId: String(it.id),
              type: 'volume',
              offerId: offerKey,
              discountPercent: discountType === 'PERCENTAGE' ? discountVal : 0,
              volumeQty: selectedQty
            };
          });
          var cart = await (await fetch('/cart.js')).json();
          var old = [];
          try { old = JSON.parse(cart.attributes._flash_deals_data || '[]'); } catch (err) {}
          var merged = (O.mergeOfferDeals)
            ? O.mergeOfferDeals(old, volDeals, offerKey)
            : old.filter(function (d) { return String(d.offerId) !== offerKey; }).concat(volDeals);
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _flash_deals_data: JSON.stringify(merged), _mm_country: O.marketCountry ? O.marketCountry() : 'BH' } }) });
          var finalCart = await (await fetch('/cart.js')).json();
          atcBtn.textContent = L.added;
          if (O.openCartSheet) await O.openCartSheet(finalCart);
          else if (window.MMCart && window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: finalCart });
          atcBtn.disabled = false;
          setTimeout(function () { atcBtn.textContent = original; }, 2000);
        } catch (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = original;
        }
      });
    }
    init();
  }

  function initOfferLogic(offer, settings, bundleItems, bogoQty, el) {
    var ar = isAr(el);
    var L = labels(settings, ar);
    var variantSelections = {};
    var tax = parseFloat(settings.taxPercentage || 10) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BHD';
    var root = shopRoot();

    function fmt(minor) {
      if (O.fmtPrice) return O.fmtPrice(minor, el);
      var div = 1000;
      var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
      if (htmlDiv === 100 || htmlDiv === 1000) div = htmlDiv;
      var total = minor * (1 + tax);
      var dec = (currency === 'BHD' || currency === 'KWD' || currency === 'OMR') ? 3 : 2;
      var amt = (total / div).toFixed(dec);
      if (ar) return amt + ' د.ب';
      return amt + ' ' + currency;
    }

    function update() {
      var total = 0, disc = 0;
      var isBogo = offer.type === 'BOGO';

      if (isBogo) {
        var triggerSel = variantSelections[0];
        var targetSel = variantSelections[1];
        var triggerPrice = triggerSel ? triggerSel.price : 0;
        var targetPrice = targetSel ? targetSel.price : 0;
        total = (triggerPrice * bogoQty.buy) + (targetPrice * bogoQty.get);
        disc = targetPrice * bogoQty.get;
      } else {
        bundleItems.forEach(function (item, idx) {
          var s = variantSelections[idx];
          if (!s) return;
          var q = s.qty || Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity) || 1));
          if (s.isFixed) s.selected.forEach(function (v) { total += v.price * q; });
          else total += s.price * q;
        });
        var mode = offer.discountMode;
        var type = offer.discountType;
        var val = parseFloat(offer.discountValue) || 0;
        if (mode === 'PER_PRODUCT') {
          bundleItems.forEach(function (item, idx) {
            var s = variantSelections[idx];
            if (!s) return;
            var q = s.qty || Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity) || 1));
            var pDisc = parseFloat(s.discount || item.discount || 0) / 100;
            if (s.isFixed) s.selected.forEach(function (v) { disc += Math.round(v.price * pDisc) * q; });
            else disc += Math.round(s.price * pDisc) * q;
          });
        } else if (type === 'PERCENTAGE') {
          disc = Math.round(total * (val / 100));
        } else if (type === 'FIXED_EACH') {
          var count = 0;
          bundleItems.forEach(function (item, idx) {
            var s = variantSelections[idx];
            if (!s) return;
            var q = s.qty || Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity) || 1));
            count += (s.isFixed ? s.selected.length : 1) * q;
          });
          disc = (val * 100) * count;
        } else {
          disc = val * 100;
        }
      }

      var final = Math.max(0, total - disc);
      var pct = total > 0 ? Math.round((disc / total) * 100) : 0;
      var newEl = document.getElementById('mm-op-price-new');
      var oldEl = document.getElementById('mm-op-price-old');
      var saveEl = document.getElementById('mm-op-savings');
      if (newEl) newEl.textContent = fmt(final);
      if (oldEl) oldEl.textContent = total > final ? fmt(total) : '';
      if (saveEl) saveEl.textContent = pct > 0 ? ((ar ? 'وفر ' : 'Save ') + pct + '%') : '';
    }

    var UI = window.MMOfferLandingUI || {};
    var products = [];

    function productForIdx(idx, optionIndex) {
      var item = bundleItems[idx];
      var isChoice = item && item.type === 'choice_group';
      if (isChoice) return (products[idx] || [])[optionIndex || 0];
      return Array.isArray(products[idx]) ? products[idx][0] : products[idx];
    }

    function productsBox() {
      return document.getElementById('mm-op-products');
    }

    function refreshRowImage(idx, product, variant) {
      var box = productsBox();
      if (!box) return;
      var row = box.querySelector('.mm-op-item-row[data-idx="' + idx + '"]');
      var imgEl = row ? row.querySelector('img.mm-op-item-img') : null;
      var url = UI.variantImageUrl(product, variant);
      if (imgEl && url) imgEl.src = url;
    }

    function mountVariantSlot(idx, product, option, item) {
      var box = productsBox();
      if (!box) return;
      var slot = box.querySelector('.mm-op-variant-slot[data-idx="' + idx + '"]');
      if (!slot) return;
      var variants = UI.filterVariants(product, option);
      var q = Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity || option.quantity || option.qty) || 1));
      if (option.isFixedSelection && variants.length > 1) {
        variantSelections[idx] = { handle: option.handle || item.handle, isFixed: true, selected: variants, qty: q, discount: option.discount || item.discount || '0' };
        slot.innerHTML = UI.buildFixedListHtml(variants, L);
        refreshRowImage(idx, product, variants[0]);
        return;
      }
      var def = variants[0];
      if (!def) return;
      variantSelections[idx] = { handle: option.handle || item.handle, isFixed: false, id: def.id, price: def.price, qty: q, discount: option.discount || item.discount || '0' };
      if (variants.length > 1) {
        slot.innerHTML = UI.buildVariantPickerHtml({ idx: idx, variants: variants, selectedId: def.id, hint: L.chooseFlavour, product: product });
        UI.wireVariantPickers(slot, {
          product: product,
          variants: variants,
          onSelect: function (picker, vid, price) {
            variantSelections[idx].id = vid;
            variantSelections[idx].price = price;
            update();
          }
        });
        refreshRowImage(idx, product, def);
      } else if (def.title !== 'Default Title') {
        slot.innerHTML = '<div class="mm-op-variant-static">' + esc(def.title) + '</div>';
        refreshRowImage(idx, product, def);
      }
    }

    async function init() {
      var box = document.getElementById('mm-op-products');
      if (!box) return;

      products = await Promise.all(bundleItems.map(async function (item) {
        try {
          if (item && item.type === 'choice_group') {
            var handles = (item.options || []).map(function (option) { return option && option.handle; }).filter(Boolean);
            return await fetchProductsJs(handles);
          }
          return await fetchProductJs(item.handle);
        } catch (e) { return null; }
      }));

      var html = '';
      bundleItems.forEach(function (item, idx) {
        var isChoice = item && item.type === 'choice_group';
        var pList = isChoice ? (Array.isArray(products[idx]) ? products[idx].filter(Boolean) : []) : [];
        var p = isChoice ? pList[0] : products[idx];
        var selectedOption = isChoice ? ((item.options || [])[0] || {}) : item;
        if (!p) return;

        var variants = UI.filterVariants(p, selectedOption);
        var q = Math.max(1, Math.floor(Number(item.quantity || item.qty || item.requiredQuantity || selectedOption.quantity || selectedOption.qty) || 1));
        if (selectedOption.isFixedSelection && variants.length > 1) {
          variantSelections[idx] = { handle: selectedOption.handle || item.handle, isFixed: true, selected: variants, qty: q, discount: selectedOption.discount || item.discount || '0' };
        } else {
          var def = variants[0];
          variantSelections[idx] = { handle: selectedOption.handle || item.handle, isFixed: false, id: def.id, price: def.price, qty: q, discount: selectedOption.discount || item.discount || '0' };
        }

        if (!document.getElementById('mm-op-gallery-main-img') && !html) {
          UI.setGalleryImage(UI.variantImageUrl(p, variants[0]));
        }

        var inner = '';
        if (isChoice) {
          inner = UI.buildChoiceGroupHtml({ products: pList, item: item, idx: idx, labels: L });
        } else {
          if (selectedOption.isFixedSelection && variants.length > 1) {
            inner = UI.buildFixedListHtml(variants, L);
          } else if (variants.length > 1) {
            inner = '<div class="mm-op-step-label mm-op-step-label--solo"><span class="mm-op-step-num">1</span>' + esc(L.chooseFlavour) + '</div>' +
              UI.buildVariantPickerHtml({ idx: idx, variants: variants, selectedId: variants[0].id, hint: L.chooseFlavour, product: p });
          } else if (variants[0] && variants[0].title !== 'Default Title') {
            inner = '<div class="mm-op-variant-static">' + esc(variants[0].title) + '</div>';
          }
        }

        var badgeHtml = '';
        var nameHtml = esc(p.title);
        if (offer.type === 'BOGO') {
          var bqty = idx === 0 ? bogoQty.buy : bogoQty.get;
          if (idx === 0) {
            badgeHtml = '<span class="mm-op-bogo-badge mm-op-bogo-badge--buy">' + esc(L.buy) + ' ' + bqty + '</span>';
          } else {
            badgeHtml = '<span class="mm-op-bogo-badge mm-op-bogo-badge--get">' + esc(L.get) + ' ' + bqty + ' ' + esc(L.free) + '</span>';
          }
        } else if (isChoice) {
          nameHtml = esc(item.label || L.chooseOneProduct);
        }

        html += '<div class="mm-op-item-row" data-idx="' + idx + '">' +
          '<img src="' + esc(UI.variantImageUrl(p, variants[0])) + '" class="mm-op-item-img" alt="">' +
          '<div class="mm-op-item-info">' +
            '<div class="mm-op-item-name">' + badgeHtml + nameHtml + '</div>' +
            (isChoice ? inner : '<div class="mm-op-variant-slot" data-idx="' + idx + '">' + inner + '</div>') +
          '</div></div>';
      });

      box.innerHTML = html || '<div class="mm-op-loading">—</div>';

      bundleItems.forEach(function (item, idx) {
        if (item && item.type === 'choice_group') {
          var pList = (products[idx] || []).filter(Boolean);
          mountVariantSlot(idx, pList[0], (item.options || [])[0] || {}, item);
        } else {
          var prod = products[idx];
          var opt = item;
          if (!(opt.isFixedSelection && UI.filterVariants(prod, opt).length > 1)) {
            UI.wireVariantPickers(box.querySelector('.mm-op-item-row[data-idx="' + idx + '"]'), {
            product: prod,
            variants: UI.filterVariants(prod, item),
            onSelect: function (picker, vid, price) {
              variantSelections[idx].id = vid;
              variantSelections[idx].price = price;
              update();
            }
          });
          var vars0 = UI.filterVariants(prod, item);
          if (vars0[0]) refreshRowImage(idx, prod, vars0[0]);
          }
        }
      });

      box.querySelectorAll('.mm-op-choice-card').forEach(function (card) {
        card.addEventListener('click', function () {
          var idx = parseInt(card.getAttribute('data-choice-idx'), 10);
          var optionIndex = parseInt(card.getAttribute('data-option'), 10) || 0;
          var block = box.querySelector('[data-choice-block="' + idx + '"]');
          if (block) block.querySelectorAll('.mm-op-choice-card').forEach(function (c) {
            c.classList.toggle('is-active', c === card);
            c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
          });
          var item = bundleItems[idx];
          var option = (item.options || [])[optionIndex] || {};
          var selectedProduct = productForIdx(idx, optionIndex);
          if (!selectedProduct) return;
          var row = box.querySelector('.mm-op-item-row[data-idx="' + idx + '"]');
          if (row) {
            var imgEl = row.querySelector('img.mm-op-item-img');
            var vars = UI.filterVariants(selectedProduct, option);
            var url = UI.variantImageUrl(selectedProduct, vars[0]);
            if (imgEl && url) imgEl.src = url;
          }
          mountVariantSlot(idx, selectedProduct, option, item);
          UI.wireVariantPickers(box.querySelector('[data-choice-block="' + idx + '"]'), {
            product: selectedProduct,
            variants: UI.filterVariants(selectedProduct, option),
            onSelect: function (picker, vid, price) {
              variantSelections[idx].id = vid;
              variantSelections[idx].price = price;
              update();
            }
          });
          update();
        });
      });

      update();
      var atc = document.getElementById('mm-op-atc');
      if (atc) atc.disabled = false;
      if (offer.endsAt) UI.startTimer(offer.endsAt, document.getElementById('mm-op-timer'), L, ar);
    }

    var atcBtn = document.getElementById('mm-op-atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', async function () {
        atcBtn.disabled = true;
        var original = atcBtn.textContent;
        atcBtn.textContent = L.adding;
        try {
          var lines = [];
          var bundleGroupId = 'bg_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          var isBogo = offer.type === 'BOGO';

          if (isBogo) {
            var triggerSel = variantSelections[0];
            var targetSel = variantSelections[1];
            var triggerVarId = triggerSel ? triggerSel.id : null;
            var freeVarId = targetSel ? targetSel.id : triggerVarId;
            var props = { _offerId: offer.id, _offerType: 'BOGO', _mmNoDiscountCodes: 'true', _bundleGroupId: bundleGroupId };
            lines.push({ id: triggerVarId, quantity: bogoQty.buy, properties: props });
            if (String(freeVarId) === String(triggerVarId)) lines[0].quantity = bogoQty.buy + bogoQty.get;
            else lines.push({ id: freeVarId, quantity: bogoQty.get, properties: props });
          } else {
            bundleItems.forEach(function (item, idx) {
              var s = variantSelections[idx];
              if (!s) return;
              var q = s.qty || Math.max(1, Math.floor(Number(item.quantity || item.qty) || 1));
              var props = { _offerId: offer.id, _offerType: offer.type, _bundleGroupId: bundleGroupId };
              if (s.isFixed) s.selected.forEach(function (v) { lines.push({ id: v.id, quantity: q, properties: props }); });
              else lines.push({ id: s.id, quantity: q, properties: props });
            });
          }

          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) });

          var newDeals = [];
          var offerKey = String(offer.id);
          if (isBogo) {
            var tSel = variantSelections[0];
            var gSel = variantSelections[1];
            var tId = tSel ? tSel.id : null;
            var gId = gSel ? gSel.id : tId;
            newDeals.push({ variantId: String(gId), isFreeGift: true, discountPercent: 100, type: 'bogo', offerId: offerKey, freeQty: bogoQty.get, triggerQty: bogoQty.buy });
            if (String(tId) !== String(gId)) newDeals.push({ variantId: String(tId), isFreeGift: false, type: 'bogo_trigger', offerId: offerKey });
          } else {
            Object.keys(variantSelections).forEach(function (idx) {
              var s = variantSelections[idx];
              if (!s) return;
              var config = bundleItems[idx] || {};
              var dValue = offer.discountMode === 'PER_PRODUCT'
                ? (parseFloat(s.discount || config.discount) || parseFloat(offer.discountValue) || 0)
                : (parseFloat(offer.discountValue) || 0);
              var q = s.qty || 1;
              if (s.isFixed) {
                s.selected.forEach(function (v) {
                  newDeals.push({ variantId: String(v.id), discountPercent: dValue, type: 'bundle', offerId: offerKey, quantity: q });
                });
              } else if (s.id) {
                newDeals.push({ variantId: String(s.id), discountPercent: dValue, type: 'bundle', offerId: offerKey, quantity: q });
              }
            });
          }

          var cart = await (await fetch('/cart.js')).json();
          var old = [];
          try { old = JSON.parse(cart.attributes._flash_deals_data || '[]'); } catch (e) {}
          var merged = (O.mergeOfferDeals)
            ? O.mergeOfferDeals(old, newDeals, offerKey)
            : old.filter(function (d) { return String(d.offerId) !== offerKey; }).concat(newDeals);
          var attributes = { _flash_deals_data: JSON.stringify(merged), _mm_country: O.marketCountry ? O.marketCountry() : 'BH' };
          if (isBogo) {
            attributes._mm_has_bogo_offer = 'true';
            attributes._mm_block_discount_codes = 'true';
          }
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes }) });
          var finalCart = await (await fetch('/cart.js')).json();
          atcBtn.textContent = L.added;
          if (O.openCartSheet) await O.openCartSheet(finalCart);
          else if (window.MMCart && window.MMCart.open) window.MMCart.open({ skipRefresh: true, cart: finalCart });
          atcBtn.disabled = false;
          setTimeout(function () { atcBtn.textContent = original; }, 2000);
        } catch (e) {
          atcBtn.disabled = false;
          atcBtn.textContent = original;
        }
      });
    }

    init();
  }

  function showError(el) {
    var ar = isAr(el);
    var L = labels({}, ar);
    el.innerHTML = '<div class="mm-op-error"><h2>' + esc(L.notFound) + '</h2><p>' + esc(L.notFoundDesc) + '</p>' +
      '<a href="' + esc(shopRoot() || '/') + '">' + esc(L.back) + '</a></div>';
  }

  async function boot() {
    var el = qs('[data-mm-offer-landing]');
    if (!el) return;
    var slug = slugFromUrl();
    if (!slug) { el.style.display = 'none'; return; }

    el.innerHTML = '<div class="mm-op-loading">' + (isAr(el) ? 'جاري تحميل العرض...' : 'Loading offer...') + '</div>';

    var data = await loadOfferBySlug(slug);
    var offer = data.offer;
    if (!offer || offer.status === 'INACTIVE') {
      showError(el);
      return;
    }

    var parsed = parseBundleItems(offer);
    var otherOffers = (data.offers || []).filter(function (o) {
      return o.id !== offer.id && o.status === 'ACTIVE' && (o.type === 'BUNDLE' || o.type === 'BOGO');
    }).slice(0, 3);

    renderShell(el, offer, data.settings || {}, otherOffers);
    if (offer.type === 'VOLUME') {
      initVolumeLogic(offer, data.settings || {}, el);
    } else {
      initOfferLogic(offer, data.settings || {}, parsed.items, parsed.bogoQty, el);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
